module.exports = __webpack_public_path__ + "static/media/homepage-title-mobile.a545aa4d.svg";